import { useEffect, useMemo, useState } from 'react'

import { useRouter } from 'next/router'

import { Locale, Timeline } from '@/service/api/landingPage'
import { useScreen } from '@/store/screen'
import { getLPTranslationData } from '@/utils/getLPTranslationData'

export const useTimelineContainer = () => {
  const { windowSize } = useScreen()

  const router = useRouter()
  const locale = (router.locale || 'pt-BR') as Locale
  const { asPath } = router

  const [timelineData, setTimelineData] = useState<Timeline>(
    () =>
      getLPTranslationData({
        landingPage: 'software',
        container: 'timelineContainer',
        locale,
      }) as Timeline,
  )

  useEffect(() => {
    const translationsObject = getLPTranslationData({
      landingPage: 'software',
      container: 'timelineContainer',
      locale,
    }) as Timeline

    setTimelineData(translationsObject)
  }, [locale, asPath])

  const fontSizesByScreenSize = useMemo(() => {
    const fontsSizesByScreen = {
      1440: {
        title: 'h4' as const,
        titleList: 'b2' as const,
      },
      500: {
        title: 'b2' as const,
        titleList: 'b4' as const,
      },
    }

    return fontsSizesByScreen
  }, [])

  const { width } = windowSize
  const fontSizes = useMemo(() => {
    if (!width) return fontSizesByScreenSize[1440]
    if (width <= 500) return fontSizesByScreenSize[500]

    return fontSizesByScreenSize[1440]
  }, [width, fontSizesByScreenSize])

  return {
    fontSizes,
    timelineData,
  }
}
